import React from "react";
import { observer } from "mobx-react-lite";

// Components
import HospitalAtomType from "~/components/atom/hospital/type/HospitalAtomType";
import HospitalAtomAddress from "~/components/atom/hospital/address/HospitalAtomAddress";
import SpecialistAtomName from "~/components/atom/specialist/name/SpecialistAtomName";
import SpecialistAtomSpeciality from "~/components/atom/specialist/speciality/SpecialistAtomSpeciality";
// Styles
import s from "~/components/common/CurrentChosenHospital/CurrentChosenHospital.module.scss";
// Hooks
import { useStore } from "~/hooks/useStore";
// Types
import RootStore from "~/store/RootStore";

interface Props {
  withSpecialistInfo?: boolean;
}

const CurrentChosenHospital: React.FC<Props> = observer(
  ({ withSpecialistInfo = false }) => {
    const store: RootStore = useStore();
    const currentSpecialist = store.specialistStore.currentSpecialist;
    const currentSpecialistSpeciality =
      store.specialistStore.currentSpecialistSpeciality;
    const currentHospital = store.hospitalStore.currentHospital;

    // Note: Стоит обработать этот кейс
    if (!currentHospital) {
      return null;
    }

    return (
      <div className={s.wrapper}>
        <div className={s.title}>
          <h2 className="headline-2">{currentHospital.organisationName}</h2>
        </div>
        <div className={s.dataContainer}>
          <div className={s.info}>
            <HospitalAtomType isPrivate={false} underline={false} />
          </div>
          <div className={s.info}>
            <HospitalAtomAddress address={currentHospital.address} />
          </div>
          {withSpecialistInfo && currentSpecialist && (
            <div className={s.info}>
              <SpecialistAtomName name={currentSpecialist.lname} />
            </div>
          )}
          {withSpecialistInfo && currentSpecialistSpeciality && (
            <div className={s.info}>
              <SpecialistAtomSpeciality
                speciality={currentSpecialistSpeciality}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default CurrentChosenHospital;
